import Fetch from "./fetch";

// Session cache for GET reference data (cities, service names, stations,
// operators...) that many tabs/screens load on mount. Concurrent callers share
// one in-flight request, and results are reused until the TTL expires.
const DEFAULT_TTL = 10 * 60 * 1000;
// For lists that can change during the day (e.g. cab operators)
export const SHORT_TTL = 2 * 60 * 1000;
const cache = new Map();

// Callers sometimes sort/splice the list they get back; don't let that leak
const copy = data => (Array.isArray(data) ? [...data] : data);

const fetchCached = async (url, ttl = DEFAULT_TTL) => {
  const hit = cache.get(url);
  if (hit && Date.now() - hit.fetchedAt < ttl) {
    return copy(await hit.promise);
  }

  const entry = { promise: Fetch(url, { method: "get" }), fetchedAt: Date.now() };
  cache.set(url, entry);
  // Drop the entry once it expires so large payloads don't sit in memory
  setTimeout(() => cache.get(url) === entry && cache.delete(url), ttl);

  const data = await entry.promise;
  // Only keep real payloads; errors / "not allowed" strings are retried next time
  if ((!data || typeof data !== "object") && cache.get(url) === entry) {
    cache.delete(url);
  }
  return copy(data);
};

// Called on logout so the next user in this tab starts with fresh data
export const clearCache = () => cache.clear();

export default fetchCached;
